import { PuppeteerApiClient } from "../utilities/PuppeteerApiClient";
import download from 'downloadjs';
import { toastSuccess } from "../utilities/messageUtils";
import type { WorkPreparationState } from "../api";

export const postPDF = async (workPrep: WorkPreparationState) => {
    try {
        const response = await PuppeteerApiClient.post('', workPrep, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toastSuccess("PDF:er uppladdade till SharePoint");
        return response.data;
    } catch (error) {
        // Error handling is done by PuppeteerApiClient interceptor
        throw error;
    }
}

export const downloadPDF = async (workPrep: any) => {
    try {
        const response = await PuppeteerApiClient.postBlob('/print', workPrep, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        // Use downloadjs to download the blob
        const filename = workPrep.tableOfContentData?.projectName?.replace(/[.\s]+$/, "") + '.pdf' || 'projekt.pdf';
        download(response.data, filename, 'application/pdf');

        toastSuccess("PDF nedladdad");
    } catch (error) {
        // Error handling is done by PuppeteerApiClient interceptor
        throw error;
    }
}
